import { Pipe, PipeTransform } from '@angular/core';
import { CustomPermissionAuthService } from '../../../shared/services/custom-permission-auth.service';

@Pipe({
  name: 'hasCustomPermissionAuth'
})
export class HasCustomPermissionAuthPipe implements PipeTransform {
  constructor(private permissionService: CustomPermissionAuthService) {}

  transform(permissions: string | string[], mode: 'all' | 'any' = 'any'): any {
    if (!permissions || (Array.isArray(permissions) && permissions.length === 0)) {
      return false;
    }
    
    const permissionArray = Array.isArray(permissions) ? permissions : [permissions];
    
    if (mode === 'all') {
      return this.permissionService.hasAllPermissions(permissionArray);
    } else {
      return this.permissionService.hasAnyPermission(permissionArray);
    }
  }

}
